import * as React from "react";
import styled from "styled-components";

import { logout } from "../../api/auth";

import { Link } from "react-router-dom";

import { Button, Link as TextLink, Text } from "@hubper/core-ui/elements";

import { select } from "@hubper/theme";
import { useUser } from "../../UserProvider";

const Base = styled.div`
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  border-bottom: 1px solid ${select.color(["grey", 2])};
`;

const Left = styled.div`
  & > * {
    margin-right: 24px;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
`;

function Nav() {
  const { user, hasPermission } = useUser();

  return (
    <Base>
      <Left>
        <Link to="/">
          <TextLink>Edit</TextLink>
        </Link>
        {hasPermission(["SETTINGS"]) && (
          <Link to="/settings">
            <TextLink>Settings</TextLink>
          </Link>
        )}
        {hasPermission(["MANAGE_USERS"]) && (
          <Link to="/users">
            <TextLink>Users</TextLink>
          </Link>
        )}
      </Left>
      <Right>
        <Text fw={"bold"} style={{ marginRight: 24 }}>
          {user.name}
        </Text>
        <Button
          onClick={async () => {
            await logout();

            window.location.href = "/login";
          }}
          type="color"
          text="Logout"
        />
      </Right>
    </Base>
  );
}

export default Nav;
